import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  forgotPasswordDialogSetEmailReducerType,
  forgotPasswordDialogSetIsLoadingReducerType,
  forgotPasswordDialogSetResultReducerType,
  forgotPasswordDialogInitStateReducerType,
} from './ForgotPasswordDialogConstants';

export const initialState = Map({
  email: '',
  isLoading: false,
  result: null,
});

const spec = {
  [forgotPasswordDialogInitStateReducerType]: (state, action) => {
    const { updatedInitialState } = action.payload;
    return initialState.merge(Map(updatedInitialState));
  },
  [forgotPasswordDialogSetEmailReducerType]: (state, action) => {
    const { email } = action.payload;
    return state.set('email', email);
  },
  [forgotPasswordDialogSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [forgotPasswordDialogSetResultReducerType]: (state, action) => {
    const { result } = action.payload;
    return state.set('result', result);
  },
};

export default createReducerBySpec(spec, initialState);
